module.exports = "<app-header *ngIf=\"accountService.isMaintainer()\" ></app-header>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main